<template>
  <div class="roomLeftAside" :class="isShowlang?'isShowlang':''"   @mouseenter="mouseenter" @mouseleave="mouseleave">
    <div  v-if="!isShowlang" class="oldSlideWidth">
      <div class="LivesTopItem">
        <div :class="upCheckStatus == 5?'svyiveSoftBox':''" class="softItem u-flex u-flex-start  u-flex-items-center"  @click="navScopeAside(5)">
          <img  v-if="upCheckStatus == 1?'iconLives2':'iconLives1'" class="iconLives2" src="/static/newroom/alllives.png" alt="">
          <img  v-if="upCheckStatus != 1?'iconLives1':'iconLives2'"  class="iconLives1" src="/static/newroom/alllive1.png" alt="">
          <span>全部直播</span>
        </div>
        <div :class="upCheckStatus == 6?'svyiveSoftBox':''" class="softItem u-flex u-flex-start  u-flex-items-center"  @click="navScopeAside(6)">
          <img  v-if="upCheckStatus != 1?'iconLives1':'iconLives2'"  class="iconLives1" src="/static/newroom/lguanzhu.png" alt="">
          <img   v-if="upCheckStatus == 1?'iconLives2':'iconLives1'" class="iconLives2"  src="/static/newroom/allguanzhu.png" alt="">
          <span>我的关注</span>
        </div>
        <div :class="upCheckStatus == 7?'svyiveSoftBox':''" class="softItem u-flex u-flex-start u-flex-items-center"  @click="navScopeAside(7)">
          <img  v-if="upCheckStatus != 1?'iconLives1':'iconLives2'"  class="iconLives1"  src="/static/newroom/llishijilu.png" alt="">
          <img  v-if="upCheckStatus == 1?'iconLives2':'iconLives1'" class="iconLives2"   src="/static/newroom/alllishijilu.png" alt="">
          <span>浏览记录</span>
        </div>
      </div>
      <div class="LivesBoxItem liveHeights" :class="{'minRoomscroll':timeState}">
        <div class="softItem softstatus u-flex u-flex-start u-flex-items-center"  @click.stop="NavPageList(hotfrist.categoryId,'')"  v-if="hotfrist.categoryName">
          <div class="u-flex u-flex-items-center" style="width: 100%;">
            <img class="iconLives1"  src="/static/newslide/hot.png" alt="">
            <img class="iconLives2"  src="/static/newslide/hot1.png" alt="">
            <span>热门</span>
            <i class="el-select__caret el-input__icon el-icon-arrow-up"></i>
          </div>
          <div class=" hoverSoftBox">
              <div class="hoverSoftBoxItem" @click.stop="NavPageList(hotfrist.categoryId,items.categoryId)" v-for="(items,indexs) in hotfrist.children" :key="indexs">
                {{items.categoryName}}
              </div>
          </div>
        </div>
        <div class="softItem softstatus u-flex u-flex-start u-flex-items-center" @click.stop="NavPageList(item.categoryId,'')" v-for="(item,index) in HotSliderList" :key="index">
          <div class="u-flex u-flex-items-center" style="width: 100%;">
            <img class="iconLives2"  :src="item.categoryIcon" alt="">
            <img class="iconLives1"  :src="item.categoryIconGrey" alt="">
            <span>{{item.categoryName}}</span>
            <i class="el-select__caret el-input__icon el-icon-arrow-up"></i>
          </div>
          <div class=" hoverSoftBox">
              <div class="hoverSoftBoxItem" @click.stop="NavPageList(item.categoryId,items.categoryId)" v-for="(items,indexs) in item.children" :key="indexs">
                {{items.categoryName}}
              </div>
          </div>
        </div>
      </div>
      <div  style="height: 152px;"></div>
      <div class="downLoadApp u-flex-y u-flex-center u-flex-items-center">
        <div class="App u-flex u-flex-items-center u-flex-center"  @click="helpItem(1)">
          <img src="/static/newroom/xiazai.png" alt="">
          <span>下载App</span>
        </div>
        <div class="App kaibo u-flex u-flex-items-center u-flex-center" @click="helpItem(1)">
          <img src="/static/newroom/kaibo.png" alt="">
          <span>我要开播</span>
        </div>
        <div class="helpkaibo"  @click="helpItem(3)">
          不知道如何开播？
        </div>
      </div>
    </div>
    <div v-else class="minRoomSlide" >
        <div class="LivesTopItem" >
          <div :class="upCheckStatus == 5?'svyiveSoftBox':''" class="softItem u-flex-y u-flex-center  u-flex-items-center"  @click="navScopeAside(5)">
            <img  v-if="upCheckStatus == 1?'iconLives2':'iconLives1'" class="iconLives2" src="/static/newroom/alllives.png" alt="">
            <img  v-if="upCheckStatus != 1?'iconLives1':'iconLives2'"  class="iconLives1" src="/static/newroom/min_zb.png" alt="">
            <span>直播</span>
          </div>
          <div :class="upCheckStatus == 6?'svyiveSoftBox':''" class="softItem u-flex-y u-flex-center  u-flex-items-center"  @click="navScopeAside(6)">
            <img  v-if="upCheckStatus != 1?'iconLives1':'iconLives2'"  class="iconLives1" src="/static/newroom/min_gz.png" alt="">
            <img   v-if="upCheckStatus == 1?'iconLives2':'iconLives1'" class="iconLives2"  src="/static/newroom/allguanzhu.png" alt="">
            <span>关注</span>
          </div>
          <div :class="upCheckStatus == 7?'svyiveSoftBox':''" class="softItem u-flex-y u-flex-center u-flex-items-center"  @click="navScopeAside(7)">
            <img  v-if="upCheckStatus != 1?'iconLives1':'iconLives2'"  class="iconLives1"  src="/static/newroom/min_his.png" alt="">
            <img  v-if="upCheckStatus == 1?'iconLives2':'iconLives1'" class="iconLives2"   src="/static/newroom/alllishijilu.png" alt="">
            <span>记录</span>
          </div>
        </div>
        <div class="LivesBoxItem LivesBoxheight" :class="{'minRoomscroll':timeState}">
          <div class="softItem softstatus u-flex-y u-flex-center u-flex-items-center"  @click.stop="NavPageList(hotfrist.categoryId,'')"  v-if="hotfrist.categoryName">
            <div class="u-flex-y u-flex-items-center" style="width: 100%;">
              <img class="iconLives1"  src="/static/newslide/hot.png" alt="">
              <img class="iconLives2"  src="/static/newslide/hot1.png" alt="">
              <span>热门</span>
            </div>
            <div class=" hoverSoftBox">
                <div class="hoverSoftBoxItem" @click.stop="NavPageList(hotfrist.categoryId,items.categoryId)" v-for="(items,indexs) in hotfrist.children" :key="indexs">
                  {{items.categoryName}}
                </div>
            </div>
          </div>
          <div class="softItem softstatus u-flex-y u-flex-center u-flex-items-center" v-for="(item,index) in HotSliderList" :key="index">
            <el-popover placement="right" popper-class="minroomhoverSoftBox" trigger="hover">
              <div class="hoverSoftList">
                  <div class="hoverSoftBoxItem"  @click.stop="NavPageList(item.categoryId,items.categoryId)"  v-for="(items,indexs) in item.children" :key="indexs">
                    {{items.categoryName}}
                  </div>
              </div>
              <div slot="reference">
                <div  @click.stop="NavPageList(item.categoryId,'')" class="u-flex-y u-flex-items-center" style="width: 100%;">
                  <img class="iconLives2"  :src="item.categoryIcon" alt="">
                  <img class="iconLives1"  :src="item.categoryIconGrey" alt="">
                  <span style="margin-top: 2px;">{{item.categoryName  | fifName}}</span>
                </div>
              </div>
            </el-popover>
          </div>
        </div>
        <div class="LivesBoxItem" style="border-top: 2px solid #F7F8FA;">
          <div class="softItem softstatus u-flex-y u-flex-center u-flex-items-center" style="margin-top: 20px;" @click="helpItem(1)"  >
            <div class="u-flex-y u-flex-items-center" style="width: 100%;">
              <img class="iconLives1" src="/static/newroom/xiazai.png" alt="">
              <img class="iconLives2" src="/static/newroom/xiazai1.png" alt="">
              <span>下载</span>
            </div>
          </div>
          <div class="softItem softstatus u-flex-y u-flex-center u-flex-items-center" @click="helpItem(1)"  >
            <div class="u-flex-y u-flex-items-center" style="width: 100%;">
              <img class="iconLives1" src="/static/newroom/kaibo2.png" alt="">
              <img class="iconLives2"  src="/static/newroom/kaibo3.png" alt="">
              <span>开播</span>
            </div>
          </div>
        </div>
    </div>
    <div class="newRoomStatus" @click="closeSlide" >
      <img v-if="!isShowlang" src="/static/newroom/left.png" alt="" srcset="">
      <img  v-else src="/static/newroom/rights.png" alt="" srcset="">
    </div>
  </div>
</template>

<script>
  import {categorieAllList,relationlives} from '@/api/lz.js'
  export default {
    props:{
      AllTabData:{
        type:Array,
        default:()=>{
          return []
        }
      }
    },
    filters:{
      fifName(val){
        return val.slice(0,2)
      }
    },
    data() {
      return {
        timeState:true,
        timeStr:'',
        isShowlang:true,
        isMoreData:false,
        upCheckStatus:1,
        'data': 'demo',
        sumHiddenScopeIndex:0,
        selectAllData:[],
        HotSliderList:[],
        hotfrist:{},
        imgList:[
          {
            iconLives1:'https://zhuayu.oss-accelerate.aliyuncs.com/admin/image/category/870d90bddd49092097ac7b6f38f2de9b00be310d.png',
            iconLives2:'https://zhuayu.oss-accelerate.aliyuncs.com/admin/image/category/863b94a8d310b963e275cc6e67d4998a8a147224.png',
          }
        ]
      }
    },
    watch:{
      AllTabData(val){
        console.log('筛选列表变化了',val);
        this.selectAllData = JSON.parse(JSON.stringify(val));
      }
    },
    created() {
      if(this.pageType == 2){
        console.log('渲染排行列表',this.AllTabData );
        this.upCheckStatus = 1
      }else{
        this.upCheckStatus = 5;
        categorieAllList({}).then((res) => {
           console.log('获取分类列表',res.data.data);
           let HotSliderList = res.data.data;
           HotSliderList.map((item,index)=>{
             // let val =  this.imgList[0];
             // item.categoryIcon = val.iconLives1;
             // item.categoryIconGrey = val.iconLives2;
              // if(item.popularFlag == 1){
              //     console.log('分类热门',item);
              //     this.hotfrist = item
              //     return item
              // }
              if(item.categoryId != 1){
                this.HotSliderList.push(item)
              }


              return item
            })
        });
      }
      let {infoId} = this.$route.query;
      console.log('是我的关注啊。。。。。',infoId);
      if(infoId == 999){
        this.upCheckStatus = 6
      }
      if(infoId == 1000){
        this.upCheckStatus = 7
      }
    },
    methods:{
      mouseleave(){
        clearTimeout( this.timeStr )
        this.timeStr = setTimeout(()=>{
          this.timeState = true;
        },1000)
      },
      mouseenter(){
        clearTimeout(this.timeStr)
        this.timeState = false;
      },
      closeSlide(){
        this.isShowlang = !this.isShowlang;
        this.$emit('Changeslide',this.isShowlang )
      },
      pageRouter(query){
        this.$store.commit('pageRouter',{
          type:1,
          query,
        })
      },
      helpItem(v){
        if(v==1){
          this.$router.push({
            path: "/pageFull",
            query: {
              rid: 9,
            },
          });
        }
        if(v==2){
          if (!localStorage.getItem("token")) {
              this.$emit('login')
              return;
          }
          this.$store.dispatch('getUserInfoData',1).then((result) => {
            console.log('获取用户信息1', result);
            if(result &&  result.userInfo && result.userInfo.identity == 2 ){
             this.pageRouter({
               path: '/tianjiazhiboyuan',
               query: {id:8,tab:2,}
             })
            }else{
              this.pageRouter({
                path: '/anchor',
              })
            }
          });
        }
        if(v==3){
          this.$router.push({
            path: "/kaiboHelp",
            query: {
              id: 8,
              tab:2,
            },
          });
        }
      },
      NavPageList(fid,cid){
        console.log('我的分类',fid,cid);
        this.$emit('changeChildAside', {
             rid: 1,
             infoId:fid,
             valId:cid
           }
        )

         // this.$router.push({
         //    path: "/pageLive",
         //    query: {
         //      rid: 1,
         //      infoId:fid,
         //      valId:cid
         //    },
         //  });
      },
      changeMoreData(){
        this.isMoreData = !this.isMoreData
      },

      sumHiddenScope(){
        let indexs = 0
        this.selectAllData.map(item=>{
          item.filtrateList.map(items=>{
            if(!items.check){
              indexs+=items.matchCount
            }
          })
        })
        this.sumHiddenScopeIndex = indexs;
      },
      selectItem(items){
        items.check = !items.check;
        this.$forceUpdate();
        this.sumHiddenScope()
      },
      navScopeAside(e){
        this.upCheckStatus = e;
        this.$emit('changeAside',e)
      }
    }
  }
</script>

<style lang="scss" scoped>

  ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 3px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;

  }

  ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    //background-color: #8c8c8c;
    background-color: rgba(0, 0, 0, 0.25);
  }

  ::-webkit-scrollbar-track {
    background-color: #f6f6f6;
  }

  ::-webkit-scrollbar-thumb,
  ::-webkit-scrollbar-track {
    border: 0;
  }

  textarea {
    resize: none;
  }
  .minRoomscroll{
    overflow-y: hidden !important;
    transition: all .1s;
  }
  .isShowlang{
    transition: all .8s;
    width: 64px !important;
  }
  .minRoomSlide{
    position: relative;
    width: 64px;
    min-height: calc(100vh - 80vh);
    background: #FFFFFF;
    .LivesBoxheight{
    overflow-y: scroll;
     height: calc(100vh - 420px);
    }
    .LivesTopItem,.LivesBoxItem {
      padding: 0 !important;
    }
    .LivesTopItem{
      margin: 12px 0;
      .softItem{
        margin-bottom: 10px;
        padding:6px 0 !important;
      }
    }
    .iconLives1{
     width: 16px !important;
     height: 16px !important;
    }
    .iconLives2{
      width: 16px !important;
      height: 16px !important;
    }
    .softItem{
      margin-bottom: 10px;
      img{

      }
      span{
        margin-top: 3px;
        font-size: 12px !important;
        font-family: PingFangSC-Medium, PingFang SC;
        margin-left: 0 !important;
        display: flex;
        font-weight: 500 !important;
      }
    }

  }
  .roomLeftAside {
    width: 240px;
    transition: all .3s;
    min-height: calc(100vh - 80px);
    border-top: 1px solid #F7F8FA;;
    border-right: 1px solid  #F7F8FA;
    background: #FFFFFF;
    position: relative;
    .oldSlideWidth{
      width: 240px;
    }
    .controlShow{
      width: 100%;
      margin-bottom: 40px;
      .controlShowUp{
        transform: rotate(0deg) !important;
      }
      .showhideeen{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }
    .bottom-footer{
      position: absolute;
      display: flex;
      bottom: 0;
      z-index:22;
      width: 240px;
      height: 54px;
      background: #FFFFFF;
      left: 50%;
      transform: translateX(-50%);
      box-shadow: 0px 2px 10px 0px rgba(46,48,52,0.3000);
      border-radius: 0px 0px 4px 4px;
      justify-content: flex-end;
      padding:10px 0;
      box-sizing: border-box;
      align-items: center;
      .allSelect{
        min-width: 30px;
       height: 26px;
       padding: 0 2px;
       text-align: center;
       margin-right: 10px;
       line-height: 26px;
       background: #F7F8FA;
       border-radius: 4px;
       font-size: 12px;
       font-family: PingFangSC-Regular, PingFang SC;
       font-weight: 400;
       color: #666666;
      }

      .allSelect:hover{
          cursor: pointer;
          background-color: #721EDC;
          color: #FFFFFF;
        }

      .numsScope{
        display: flex;
        padding-left: 12px;
        align-items: center;
        justify-content: flex-start;
        flex: 2;
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }


    .downLoadApp{
      background: #FFFFFF;
      position: fixed;
      width: 240px;
      height: 152px;
      bottom: 0;
      .helpkaibo:hover{
        color: #721EDC !important;
      }
      .helpkaibo{
        cursor: pointer;
        margin: 8px;
        height: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 12px;
      }
      .kaibo{
        margin-top: 12px;
        background-color: #721EDC !important;
        span{
          color: #FFFFFF !important;
        }
      }
      .App{
        cursor: pointer;
        width: 192px;
        height: 44px;
        background: #fff;
        border-radius: 4px;
        border: 1px solid #D9D9D9;
        img{
          width: 16px;
          height: 16px;

        }
        span{
          margin-left: 12px;
          display: inline-block;
         font-size: 16px;
         font-family: PingFangSC-Regular, PingFang SC;
         font-weight: 400;
         color: #595959;
        }
      }
    }
    .liveHeights{
      height:calc(100vh - 170px - 64px - 152px);
    }

    .newRoomStatus{
      cursor: pointer;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: -12px;
      img{
        width: 12px;
        height: 60px;

      }
    }
    .LivesBoxItem {
      padding: 12px 12px 0 24px;
      box-sizing: border-box;
      overflow-y: auto;
      border-bottom: none !important;
      // margin-bottom: 152px;
      .softstatus {
        display: flex;
        flex-direction: column;
        padding: 0 0 16px 0 !important;
        span{
          flex: 2;
        }
        i{
          transform: rotate(180deg);
          transition: all .2s;
        }
      }
    }
    .scopeHeight{

      height: calc(100vh - 170px - 64px - 100px);
      overflow-y: auto;
    }
    .LivesTopItem,
    .LivesBoxItem {
      padding: 12px 12px 0 24px;
      box-sizing: border-box;
      border-bottom: 2px solid  #F7F8FA;
      .moreMyrows{
        max-height:auto !important;
        transition: all .3s;
        overflow-y: scroll;
      }
      .minMyrows{
        max-height:153px;
        overflow: hidden;
        transition: all .3s;
      }
      .Myrows{
        display: flex;
        width: 100%;
        align-items: flex-start;
        flex-direction: column !important;

        .asideList{
          display: flex;
          flex-flow: column;
        }
        .cellListaside{
          display: flex;
          flex-flow: row wrap;
        }
        // .hoverSoftBoxItem:nth-child(3n){
        //   margin-right: 0 !important;
        // }
        .acTivesSoftBoxItem{
          cursor: pointer;
          background-color: #721EDC !important;
          color: #FFFFFF !important;
        }
        .hoverSoftBoxItem:hover{
          cursor: pointer;
          background-color: #721EDC;
          color: #FFFFFF;
        }
        .leftname{
          height: 26px;
          font-size: 12px;
          margin-top: 11px;
          line-height: 26px;
        }
        .hoverSoftBoxItem{
          margin-top: 11px;
          padding:0 6px;
          text-align: center;
          margin-right: 12px;
          min-width: 56px;
          height: 26px;
          line-height: 26px;
          background: #F7F8FA;
          border-radius: 4px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
      }
      .svyiveSoftBox{
          .hoverSoftBoxItem{
            cursor: pointer;
            background-color: #721EDC ;
            color: #FFFFFF;
          }
          span{
              color: #721EDC !important;
              cursor: pointer;
          }
          .defineDown{
            color: #721EDC;
            transform: rotate(0deg) !important;
            transition: all .3s;
          }
          .iconLives1{
           display: none !important;
          }
          .iconLives2{
            display: block !important;
          }
          .hoverSoftBox{
            height: auto;
          }

      }
      .hoverSoftBox{
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        max-height:0px;
        overflow: hidden;
        transition: all .3s;
        .hoverSoftBoxItem:nth-child(3n){
          margin-right: 0 !important;
        }
        .hoverSoftBoxItem:hover{
          cursor: pointer;
          background-color: #721EDC;
          color: #FFFFFF;
        }
        .hoverSoftBoxItem{
          margin-top: 11px;
          text-align: center;
          margin-right: 12px;
          width: 56px;
          height: 26px;
          line-height: 26px;
          background: #F7F8FA;
          border-radius: 4px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
      }

      .softItem:hover{

        .hoverSoftBox{
            transition: all .5s;
            max-height:114px;
            overflow-y: scroll;
        }
        span{
            color: #721EDC !important;
            cursor: pointer;
        }
        .transform{
          color: #721EDC;
          transform: rotate(0deg) !important;
          transition: all .3s;
        }
        .iconLives1{
          display: none;
        }
        .iconLives2{
          display: block;
        }
        .hoverSoftBox{
          height: auto;
        }
      }
      .softItem {
        padding: 14px 0;
        .iconLives1{
          display: block;
        }
        .iconLives2{
          display: none;
        }
        img {
          width: 20px;
          height: 20px;
        }
        span {
          margin-left: 6px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #333333;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lz_leftAside.vue